module.exports = __webpack_public_path__ + "img/logo-loading.1320bc14.png";